import { Util } from './Util';
import { StorageService } from "./StorageService";

export abstract class ApiClient {
  private _authToken: string;

  constructor() {
    this._authToken = StorageService.loadAuthToken();
  }

  get baseUrl(): string {
    return Util.apiBaseUrl();
  }

  get headers(): Record<string, string> {
    return {
      'Authorization': `Basic ${this._authToken || ''}`,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
  }

  protected updateAuthToken(token: string): void {
    this._authToken = token;
    StorageService.saveAuthToken(token);
  }

  async fetch(
    path: string,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE',
    body: any = null
  ): Promise<string | any> {
    const url = `${this.baseUrl}${path.startsWith('/') ? '' : '/'}${path}`;

    const res = await fetch(url, {
      headers: this.headers,
      method: method,
      body: body ? JSON.stringify(body) : null
    });

    return this._handleResponse(res);
  }

  private async _handleResponse(res: Response): Promise<any> {
    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      throw new Error(`${res.status} ${res.statusText}${txt ? `: ${txt.slice(0, 300)}` : ''}`);
    }
    const ct = res.headers.get('content-type') || '';

    return ct.includes('application/json')
      ? res.json()
      : res.text();
  }
}